const API = process.env.REACT_APP_BACKEND_URL;

const tapType = (href = '') => {
  if (href.startsWith('tel:')) return 'call';
  if (/wa\.me|whatsapp\.com/i.test(href)) return 'whatsapp';
  if (/calendly\.com/i.test(href)) return 'calendly';
  return null;
};

// Records call / WhatsApp / Calendly button taps anywhere on the site.
export const installTapTracker = () => {
  const onClick = (e) => {
    const a = e.target.closest && e.target.closest('a[href]');
    const type = a && tapType(a.getAttribute('href'));
    if (!type) return;
    const params = new URLSearchParams(window.location.search);
    const body = JSON.stringify({
      type,
      page: window.location.pathname,
      label: (a.getAttribute('data-testid') || a.textContent || '').trim().slice(0, 120),
      href: a.getAttribute('href'),
      utm_source: params.get('utm_source'),
      utm_campaign: params.get('utm_campaign'),
    });
    const url = `${API}/api/track`;
    const blob = new Blob([body], { type: 'text/plain' });
    if (!(navigator.sendBeacon && navigator.sendBeacon(url, blob))) {
      fetch(url, { method: 'POST', body, headers: { 'Content-Type': 'text/plain' }, keepalive: true }).catch(() => {});
    }
  };
  document.addEventListener('click', onClick, true);
  return () => document.removeEventListener('click', onClick, true);
};
